import React from 'react';

import './style.scss';

function Icon({icon = ''}) {
  return <i className={`Icon awsicon-${icon}`}/>;
}

export default Icon;
